(() => {
 const hub=document.querySelector('.tc171-hub');
 if(hub){
  const rows=[...hub.querySelectorAll('[data-topic]')];
  const search=hub.querySelector('#topic-search');
  const buttons=[...hub.querySelectorAll('[data-filter]')];
  const groups=[...hub.querySelectorAll('[data-family-group]')];
  const tabList=hub.querySelector('[role="tablist"]');
  const result=hub.querySelector('.tc171-results');
  const empty=hub.querySelector('.tc171-empty');
  const catalog=hub.querySelector('.tc171-catalog');
  const labels=new Map(buttons.map(b=>[b.dataset.filter,b.querySelector('.tc171-tab-label').textContent]));
  const defaultFamily=buttons[0].dataset.filter;
  let family=defaultFamily;
  const norm=s=>s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[’']/g,'');
  const topicCount=n=>n+' '+(n===1?'topic':'topics');
  function revealSelectedTab(){
   const selected=buttons.find(b=>b.dataset.filter===family);
   const left=selected.offsetLeft,right=left+selected.offsetWidth;
   if(left<tabList.scrollLeft)tabList.scrollLeft=left;
   else if(right>tabList.scrollLeft+tabList.clientWidth)tabList.scrollLeft=right-tabList.clientWidth;
  }
  function update(preferMatching=false){
   const terms=norm(search.value.trim()).split(/\s+/).filter(Boolean);
   const matches=new Map(rows.map(row=>[row,terms.every(t=>norm(row.dataset.search).includes(t))]));
   const counts=new Map(buttons.map(b=>[b.dataset.filter,rows.filter(row=>row.dataset.family===b.dataset.filter&&matches.get(row)).length]));
   const total=[...matches.values()].filter(Boolean).length;
   if(preferMatching&&total&&!counts.get(family))family=buttons.find(b=>counts.get(b.dataset.filter)).dataset.filter;
   for(const row of rows){
    row.hidden=row.dataset.family!==family||!matches.get(row);
    if(row.hidden)row.querySelector('details').open=false;
   }
   groups.forEach(group=>{group.hidden=group.dataset.familyGroup!==family;});
   buttons.forEach(b=>{
    const selected=b.dataset.filter===family;
    b.setAttribute('aria-selected',String(selected));b.tabIndex=selected?0:-1;
    b.querySelector('[data-count]').textContent=String(counts.get(b.dataset.filter));
    b.setAttribute('aria-label',labels.get(b.dataset.filter)+', '+topicCount(counts.get(b.dataset.filter))+(terms.length?' matching search':''));
   });
   catalog.dataset.selectedFamily=family;
   revealSelectedTab();
   const visible=counts.get(family);
   result.textContent=terms.length?topicCount(total)+' matching “'+search.value.trim()+'” · '+visible+' in '+labels.get(family)+(total?'. Select a tab with matches.':'. Try a broader phrase or reset your search.'):topicCount(visible)+' in '+labels.get(family)+' · '+rows.length+' across all families.';
   empty.hidden=visible!==0;
   empty.querySelector('h2').textContent=total?'No matching topics in '+labels.get(family):'No matching topics';
   empty.querySelector('p').textContent=total?topicCount(total)+' match in other families. Select a tab with matches, or reset your search.':'Try a broader phrase or reset to all '+rows.length+' topics.';
  }
  search.addEventListener('input',()=>update(true));
  buttons.forEach(b=>b.addEventListener('click',()=>{family=b.dataset.filter;update();}));
  tabList.addEventListener('keydown',event=>{
   const current=buttons.indexOf(event.target.closest('[role="tab"]'));
   if(current<0)return;
   let next=current;
   if(event.key==='ArrowRight')next=(current+1)%buttons.length;
   else if(event.key==='ArrowLeft')next=(current-1+buttons.length)%buttons.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=buttons.length-1;
   else return;
   event.preventDefault();family=buttons[next].dataset.filter;update();
   buttons[next].focus({preventScroll:true});
  });
  hub.querySelectorAll('[data-reset]').forEach(b=>b.addEventListener('click',()=>{search.value='';family=defaultFamily;update();if(b.closest('.tc171-empty'))search.focus();}));
  for(const detail of hub.querySelectorAll('.tc171-explanation')){
   detail.addEventListener('toggle',()=>{if(detail.open)for(const other of hub.querySelectorAll('.tc171-explanation'))if(other!==detail)other.open=false;});
  }
  function returnToTopic(){
   const anchor=decodeURIComponent(location.hash.slice(1));
   const row=rows.find(r=>r.id===anchor);
   if(!row)return;
   search.value='';family=row.dataset.family;update();
   requestAnimationFrame(()=>{row.scrollIntoView({block:'start'});row.querySelector('summary').focus({preventScroll:true});});
  }
  addEventListener('hashchange',returnToTopic);
  addEventListener('resize',revealSelectedTab);
  update();returnToTopic();
 }
 document.querySelectorAll('video').forEach(video=>video.addEventListener('play',()=>document.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();})));
})();

/* W363: explicit direct playback or an informed, per-player YouTube load action.
   No remote iframe, API, poster or preconnect is created before that action. */
(() => {
 document.querySelectorAll('[data-player]').forEach(frame=>{
  const scope=frame.closest('.player-block')||document;
  const video=frame.querySelector('video'),poster=frame.querySelector('.poster');
  const status=frame.querySelector('[role="status"]'),play=frame.querySelector('[data-play]');
  // D7: a real <video> already carries its <source>, poster and preload="none" in the HTML.
  // Nothing but the cover image loads before play; the Watch control only starts playback.
  if(frame.hasAttribute('data-d7-real')&&video&&video.querySelector('source')){
   const watch=frame.querySelector('[data-d7-watch]');
   const say=text=>{if(status)status.textContent=text;};
   let revealed=false;
   const reveal=()=>{if(revealed)return;revealed=true;video.setAttribute('controls','');if(watch)watch.hidden=true;say('');};
   const start=()=>{reveal();const attempt=video.play();if(attempt&&attempt.catch)attempt.catch(()=>say(frame.dataset.pressPlay||'Press Play in the video controls to continue.'));};
   frame.dataset.providerState='ready';
   if(watch){
    video.removeAttribute('controls');
    watch.addEventListener('click',()=>{start();video.focus({preventScroll:true});});
    video.addEventListener('click',event=>{if(!revealed){event.preventDefault();start();}});
   }
   video.addEventListener('play',()=>{reveal();frame.dataset.playbackState='playing';});
   video.addEventListener('pause',()=>{frame.dataset.playbackState='paused';});
   video.addEventListener('loadedmetadata',()=>{frame.dataset.loadedDuration=String(video.duration);});
   const lastSource=video.querySelector('source:last-of-type');
   if(lastSource)lastSource.addEventListener('error',()=>say(frame.dataset.mediaError||'This video could not be opened. The saved text remains available.'));
   return;
  }
  const consent=frame.querySelector('[data-provider-consent]'),load=frame.querySelector('[data-provider-load]');
  const cancel=frame.querySelector('[data-provider-cancel]'),close=frame.querySelector('[data-provider-close]');
  const external=frame.querySelector('[data-provider-external]');
  // A lesson has one player; fixture scopes its own chapter control to each case.
  const buttons=frame.closest('[data-provider-fixture]')?scope.querySelectorAll('[data-seek]'):document.querySelectorAll('[data-seek]');
  const provider=frame.dataset.provider||'direct';
  let requestedTime=0,iframe=null,perPlayerConsent=false;
  const validID=/^[A-Za-z0-9_-]{11}$/.test(frame.dataset.youtubeId||'');
  function safeDirectURL(value){
   try{
    const url=new URL(value,location.href),host=url.hostname.toLowerCase();
    if(!value||host==='youtu.be'||host==='youtube.com'||host.endsWith('.youtube.com')||host==='youtube-nocookie.com'||host.endsWith('.youtube-nocookie.com'))return false;
    return url.protocol==='https:'||(url.protocol==='http:'&&['127.0.0.1','localhost','[::1]'].includes(host));
   }catch{return false;}
  }
  const qualified=frame.dataset.qualified==='true';
  const allowed=qualified&&(provider==='direct'?safeDirectURL(frame.dataset.src):provider==='youtube'&&validID&&['public','unlisted'].includes(frame.dataset.visibility)&&frame.dataset.embedAllowed==='true');
  if(!allowed){
   frame.dataset.providerState='blocked';play.hidden=true;
   if(video)video.hidden=true;
   buttons.forEach(button=>button.disabled=true);
   status.textContent=frame.dataset.pending||'Video preview is pending a verified native media binding. The lesson text remains available below.';
   return;
  }
  frame.dataset.providerState='ready';
  function setStatus(text){status.textContent=text;}
  function startYouTube(){
   if(!perPlayerConsent)return;
   if(iframe)iframe.remove();
   iframe=document.createElement('iframe');
   const params=new URLSearchParams({autoplay:'1',playsinline:'1',cc_load_policy:'1',cc_lang_pref:'en',hl:'en',rel:'0',start:String(Math.floor(requestedTime))});
   iframe.src='https://www.youtube-nocookie.com/embed/'+frame.dataset.youtubeId+'?'+params;
   iframe.title=frame.dataset.title||'Lesson video on YouTube';
   iframe.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';
   iframe.allowFullscreen=true;iframe.referrerPolicy='strict-origin-when-cross-origin';
   iframe.className='youtube-player';
   poster.hidden=true;consent.hidden=true;close.hidden=false;
   external.hidden=false;external.href='https://www.youtube.com/watch?v='+frame.dataset.youtubeId+'&t='+Math.floor(requestedTime)+'s';
   frame.insertBefore(iframe,close);
   frame.dataset.providerState='youtube-loaded';frame.dataset.requestedTime=String(requestedTime);
   // This is a requested chapter, not an observed current playback position.
   setStatus(frame.dataset.youtubeNote||'YouTube provides playback and captions. If the embedded player cannot open, watch on YouTube.');
   iframe.focus({preventScroll:true});
  }
  function playAt(time){
   requestedTime=Number.isFinite(Number(time))?Math.max(0,Number(time)):0;
   const duration=Number(frame.dataset.duration);
   if(duration>0)requestedTime=Math.min(requestedTime,Math.max(0,duration-.1));
   if(provider==='youtube'){
    if(!perPlayerConsent){
     consent.hidden=false;frame.dataset.providerState='consent-pending';
     setStatus('');load.focus({preventScroll:true});return;
    }
    startYouTube();return;
   }
   if(!video.getAttribute('src')){
    video.src=frame.dataset.src;
    if(frame.dataset.caption){
     const track=document.createElement('track');track.kind='captions';track.srclang='en';track.label=frame.dataset.captionsLabel||'English — review draft';track.src=frame.dataset.caption;track.default=true;video.append(track);
    }
   }
   poster.hidden=true;video.hidden=false;setStatus('');
   const seek=()=>{if(Number.isFinite(video.duration))video.currentTime=Math.min(requestedTime,Math.max(0,video.duration-.1));};
   if(video.readyState>=1)seek();else video.addEventListener('loadedmetadata',seek,{once:true});
   video.play().catch(()=>setStatus(frame.dataset.pressPlay||'Press Play in the video controls to continue.'));
   video.focus({preventScroll:true});
  }
  play.addEventListener('click',()=>playAt(0));
  buttons.forEach(button=>button.addEventListener('click',()=>{playAt(button.dataset.seek);frame.scrollIntoView({block:'center',behavior:'auto'});}));
  if(provider==='youtube'){
   load.addEventListener('click',()=>{perPlayerConsent=true;startYouTube();});
   cancel.addEventListener('click',()=>{consent.hidden=true;frame.dataset.providerState='ready';play.focus({preventScroll:true});});
   close.addEventListener('click',()=>{
    if(iframe)iframe.remove();iframe=null;perPlayerConsent=false;
    poster.hidden=false;close.hidden=true;external.hidden=true;external.removeAttribute('href');consent.hidden=true;
    frame.dataset.providerState='ready';delete frame.dataset.requestedTime;setStatus('');play.focus({preventScroll:true});
   });
   return;
  }
  video.addEventListener('error',()=>setStatus(frame.dataset.mediaError||'This video could not be opened. The saved text remains available.'));
  // DOM diagnostics mirror native controls; nothing is transmitted as analytics.
  video.addEventListener('loadedmetadata',()=>{frame.dataset.loadedDuration=String(video.duration);});
  video.addEventListener('playing',()=>{frame.dataset.playbackState='playing';});
  video.addEventListener('pause',()=>{frame.dataset.playbackState='paused';});
  video.addEventListener('timeupdate',()=>{
   frame.dataset.currentTime=String(video.currentTime);
   document.querySelectorAll('.chapters [data-seek]').forEach((button,i,all)=>{
    const active=video.currentTime>=Number(button.dataset.seek)&&(!all[i+1]||video.currentTime<Number(all[i+1].dataset.seek));
    button.setAttribute('aria-current',active?'true':'false');
   });
  });
 });
})();
